/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunicationDto } from '../../models/communication-dto';

export interface CreateCommunicationByEntity$Params {
  entityType: 'ContactPerson' | 'Customer';
  entityId: number;
      body: CommunicationDto
}

export function createCommunicationByEntity(http: HttpClient, rootUrl: string, params: CreateCommunicationByEntity$Params, context?: HttpContext): Observable<StrictHttpResponse<CommunicationDto>> {
  const rb = new RequestBuilder(rootUrl, createCommunicationByEntity.PATH, 'post');
  if (params) {
    rb.path('entityType', params.entityType, {});
    rb.path('entityId', params.entityId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CommunicationDto>;
    })
  );
}

createCommunicationByEntity.PATH = '/communications/{entityType}/{entityId}';
